import React from 'react'

export default function VoiceOutreach() {
  return (
        <div className="about_area voice-outreach">
      <div className="container">
        <div className="row">
         <div className="col-lg-7 col-md-6 col-sm-12 col-xs-6">
            
            <div className="singel_about_left text-left">
              
             
             
               <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 <div className="section_main_title">
                <h3>Results</h3>
              
              </div>
                  <p>
                  ● Achieved 6-month goals in just 3 months
                  <br/> ● Delivered BANT-qualified leads across all regions
                  <br/>  ● Prospects engaged at multiple decision-making levels

                  </p>
                </div>
              </div>
              
             
               <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                <div className="singel-about-content">
                 
                  <p>
                  <b>India led in volume:</b><br/>● 51.6% of total contacts
                <br/>● Strong response to innovation-driven messaging

                  </p>
                  <p><b>ANZ & ASEAN showed:</b><br/>● Higher-quality engagement
<br/>● Strong interest in analytics-led transformation
</p>
<p>MAL pipeline fully bridged, keeping the funnel sales-ready post-campaign</p>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-5 col-md-6 col-sm-12 col-xs-6">
            {/* <div className="section_title text_left mb-40 mt-3 text-left">
           
              <div className="section_main_title">
                <h2>ProPlus Data</h2>
              
              </div>
             
              
            </div> */}
            <div className="singel_about_left mb-30 text-left">
              
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                  
                </div>
                <div className="singel-about-content">
                 
                  <p>
                
                  </p>
                </div>
              </div>
              <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 
                  <p>
               
                  </p>
                </div>
              </div>
               <div className="singel_about_left_inner d-flex align-items-center">
                <div className="about_icon mr-3">
                
                </div>
                <div className="singel-about-content">
                 
                  <p>
              
                  </p>
                </div>
              </div>
             
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
